import { auth } from '../firebase';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3800";

/**
 * Searches for address suggestions using the address API
 * @param {string} query - The address query string (minimum 3 characters)
 * @returns {Promise<Array>} - Array of address suggestions
 * @throws {Error} - Throws an error if the search fails or user is not authenticated
 */
export const searchAddressSuggestions = async (query) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not authenticated.");
  }

  if (!query || query.length < 3) {
    return [];
  }

  try {
    const idToken = await user.getIdToken();
    const url = `${BASE_URL}/address/suggestions?query=${encodeURIComponent(query)}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(responseData.message || `HTTP error! status: ${response.status}`);
    }

    if (responseData.status !== 'success') {
      throw new Error(responseData.message || 'Failed to fetch address suggestions');
    }

    return responseData.data?.suggestions || [];
  } catch (error) {
    console.error('Error fetching address suggestions:', error);
    throw error;
  }
};
